export default __webpack_public_path__ + "static/media/logo_ro_vertical.ce85efdc.png";